import useTypewriter from "../hooks/useTypewriter";
import { RiRestartLine } from "react-icons/ri";
import { useTheme } from "styled-components";
import Timer from "./Timer";

export default function TypingArea({ difficulty, time, setTime }) {
  const {
    value,
    setValue,
    setStartedTyping,
    currentWord,
    score,
    success,
    displayRestart,
    setRestart,
  } = useTypewriter(difficulty, time, setTime);
  /*******/
  const currentTheme = useTheme();
  const inputClasses = [
    "border-0",
    currentTheme.border,
    "border-b-2",
    "bg-transparent",
    "py-2 px-3",
    "placeholder:text-gray-400 placeholder:font-mono placeholder:font-thin placeholder:text-lg",
    "outline-none",
    "caret-cyan-100",
    currentTheme.textSecondary,
    "font-mono",
    "text-lg",
    "min-w-full",
  ];
  return (
    <>
      <div className="flex flex-col items-center py-8 my-5 mx-auto px-4 md:px-0 font-mono lg:w-3/4 w-full">
        <div className={`flex items-center gap-3 ${currentTheme.textPrimary}`}>
          <small className="font-medium text-sm">current word</small> -{" "}
          <span
            className={`font-thin text-4xl mb-2 ${currentTheme.textSecondary}`}
          >
            {currentWord}
          </span>
        </div>
        <div className="mt-11 flex justify-between items-center md:items-baseline min-w-full">
          <p className={`${currentTheme.textPrimary} text-sm md:text-base`}>
            Enter each word within the given limit
          </p>
          <small className="text-cyan-100 flex gap-3 items-center text-sm">
            <span>limit</span>-
            <span
              className={`text-lg tracking-wider ${currentTheme.textSecondary}`}
            >
              {difficulty.limit}
              <span className={`text-sm ${currentTheme.textPrimary}`}>s</span>
            </span>
          </small>
        </div>
        {/* Input / Typing section */}
        <div className="mt-10 min-w-full">
          <input
            type="text"
            id="typed_text"
            name="typed_text"
            placeholder="Enter current word..."
            autoComplete="off"
            className={inputClasses.join(" ")}
            onInput={() => setStartedTyping(true)}
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
          <small
            style={{ fontSize: "0.7rem" }}
            className="mt-2 inline-block italic text-cyan-100"
          >
            Space required at the end of the word to proceed.
          </small>
        </div>
        {/*  */}
        <div
          className="mt-7 ml-auto flex justify-between"
          style={{ width: "53%" }}
        >
          <button
            tabIndex={!displayRestart ? "-1" : "0"}
            onClick={() => setRestart(true)}
            className={`outline-none transition-colors hover:bg-gray-600 hover:opacity-75 focus:opacity-50 rounded-full p-2 ${
              !displayRestart && "select-none pointer-events-none"
            }`}
          >
            {displayRestart && (
              <RiRestartLine
                className={`${currentTheme.textSecondary} text-2xl`}
              />
            )}
          </button>
          <small className="flex gap-3 items-center text-cyan-100">
            <span>current score</span>-
            <span className={`${currentTheme.textPrimary} text-lg`}>
              {score}
            </span>
          </small>
        </div>
      </div>
      <Timer time={time} success={success} />
    </>
  );
}
